import React, { useMemo, useState } from "react";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../../../Utils/renderField/renderReadField";
import Badge from "../../../../../../../../Utils/Badge/Badge";
import {
    PalletsReclasificacion,
    construirItemsReclasificacion,
} from "../../../../../components/PalletsReclasificacion/PalletsReclasificacion";
import { agruparPalletsPorProducto } from "../../../../../../helpers/groupPallets";
import { NumeroPallet } from "../../../../../../components/NumeroPallet/NumeroPallet";
import NullableValue from "../../../../../../../../Utils/renderField/nullableValue";

export const PalletsTable = (props) => {
    const { pallets = [], headerText = "Pallets formados" } = props;

    const palletsAgrupados = useMemo(
        function () {
            return agruparPalletsPorProducto(pallets);
        },
        [pallets],
    );

    return (
        <React.Fragment>
            <h5>{headerText}</h5>
            <div className="new-table-wrapper detalle-paletizacion__table-wrapper mb-4">
                <table>
                    <thead>
                        <tr>
                            <th>Prod. conforme</th>
                            <th>Tarjeta roja</th>
                            <th>EVS</th>
                            <th>Pallet</th>
                            <th>Cant. pacas</th>
                            <th>Pacas turno actual</th>
                            <th>Pacas turno anterior</th>
                            <th>Pacas en reclasificación</th>
                            <th>Pallets en reclasificación</th>
                            <th>Kg hule seco</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pallets.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={10}>
                                    No se han agregado pallets.
                                </td>
                            </tr>
                        )}
                        {palletsAgrupados.map(function (productoData) {
                            return (
                                <React.Fragment key={productoData.id}>
                                    {/* Encabezado producto */}
                                    <tr className="detalle-paletizacion__producto-row">
                                        <td colSpan={10}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <span>
                                                    {productoData.padreNombre
                                                        ? `${productoData.padreNombre} - ${productoData.nombre}`
                                                        : productoData.nombre}
                                                </span>

                                                <span>
                                                    Sub-total:{" "}
                                                    <RenderKilogramo
                                                        value={
                                                            productoData.subtotalKg
                                                        }
                                                        decimalScale={2}
                                                    />
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* Detalle */}
                                    {productoData.pallets.map(function (item) {
                                        return (
                                            <tr key={item.id}>
                                                <td className="text-center">
                                                    {item.es_conforme ? (
                                                        <Badge
                                                            text="Sí"
                                                            variant="success"
                                                        />
                                                    ) : (
                                                        <Badge
                                                            text="No"
                                                            variant="danger"
                                                        />
                                                    )}
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <NullableValue
                                                        value={
                                                            item.tarjeta_salida
                                                        }
                                                    >
                                                        <Badge
                                                            text={
                                                                item.tarjeta_salida
                                                            }
                                                            variant={"danger"}
                                                        />
                                                    </NullableValue>
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    {item.evs_numero}
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <NumeroPallet
                                                        pallet={item}
                                                    />
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.total_pacas ||
                                                            0
                                                        }
                                                    />
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.pacas_turno_actual ||
                                                            0
                                                        }
                                                    />
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.pacas_turno_anterior ||
                                                            0
                                                        }
                                                    />
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.total_pacas_reclasificacion ||
                                                            0
                                                        }
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <PalletsReclasificacion
                                                        pallets={construirItemsReclasificacion(
                                                            item,
                                                        )}
                                                    />
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <RenderKilogramo
                                                        value={item.total_peso}
                                                        decimalScale={2}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
